import { useDeviceName } from '../../lib/api/myRobot';
import { mapDockOsdToOverview } from '../../store/dock/dji-dock3/dji-dock3.actions.ts';
import { KeyPathParser, useTwinFetcherQuery, useTwinQuerySub } from '../signalR';


export function useReportedDroneOSD() {
  const { deviceName } = useDeviceName();
  const { keyPath, parser } = KeyPathParser.DroneOSD;
  return useTwinQuerySub(keyPath(deviceName), parser);
}

export function useReportedDroneOsdModeCode() {
  const { deviceName } = useDeviceName();
  const { keyPath, parser } = KeyPathParser.DroneOSD.modeCode;
  return useTwinQuerySub(keyPath(deviceName), parser);
}

export function useReportedDroneOsdModeCodeReason() {
  const { deviceName } = useDeviceName();
  const { keyPath, parser } = KeyPathParser.DroneOSD.modeCodeReason;

  return useTwinQuerySub(keyPath(deviceName), parser);
}

export function useReportedDockOSD() {
  const { deviceName } = useDeviceName();
  const { keyPath, parser } = KeyPathParser.DockOSD;
  const { data: dockOSD } = useTwinQuerySub(keyPath(deviceName), parser);
  return { dockOSD };
}

/* Overview of Dock OSD: most important data */
export function useDockOSDOverview() {
  const { dockOSD } = useReportedDockOSD();

  const overviewData = mapDockOsdToOverview(dockOSD);

  return { overviewData };
}

export function useReportedDroneOsdGimbal() {
  const { deviceName } = useDeviceName();
  const { keyPath, parser } = KeyPathParser.DroneOSD.gimbalIndex;
  const { data: gimbal } = useTwinQuerySub(keyPath(deviceName), parser);

  return gimbal;
}

export function useReportedDroneOsdGimbalPayloadIndex() {
  const { deviceName } = useDeviceName();
  const { keyPath, parser } = KeyPathParser.DroneOSD.gimbalIndex.payloadIndex;
  const { data: gimbalPayloadIndex } = useTwinFetcherQuery(keyPath(deviceName), parser);

  return { gimbalPayloadIndex };
}